import Head from 'next/head';
import { HeadTitleContent } from '../../../commons/Constants';
import { config } from '../../../config';
import { productImages } from '../../images';
import TurmericPage from '../../../components/body/turmeric';

export default function Turmeric() {
  const path_url = config.SiteURL.slice(0, -1);
  return (
    <>
      <Head>
        <meta
          property="og:title"
          content={HeadTitleContent['turmeric'].title}
          key="ogtitle"
        />
        <meta
          property="og:description"
          content={HeadTitleContent['turmeric'].description}
          key="ogdescription"
        />
        <meta
          property="og:url"
          content={path_url + HeadTitleContent['turmeric'].path}
          key="ogurl"
        />
        <meta
          property="og:image"
          content={path_url + productImages['turmericImageStr']}
          key="ogimage"
        />
      </Head>
      <TurmericPage />
    </>
  );
}
export async function getStaticProps(context) {
  return {
    props: {
      extraMeta: {
        title: HeadTitleContent['turmeric'].title,
        description: HeadTitleContent['turmeric'].description,
      },
    },
  };
}
